// CORE
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// COMPONENTS

import { EFeatureFlag } from '@app/feature-toggle-list';
import { FeatureGuard } from '@app/shared/guards';
import {
  CustomFieldComponent,
  CustomFieldFormComponent,
  CustomFieldDetailsComponent,
} from 'v2/modules/custom-field/components';

const routes :Routes = [
  {
    path: '',
    component: CustomFieldComponent,
    canActivate: [FeatureGuard],
    data: {
      feature: EFeatureFlag.CUSTOM_FIELDS,
    },
  },
  {
    path: 'create',
    component: CustomFieldFormComponent,
    canActivate: [FeatureGuard],
    data: {
      feature: EFeatureFlag.CUSTOM_FIELDS,
    },
  },
  {
    path: 'edit/:customFieldId',
    component: CustomFieldFormComponent,
    canActivate: [FeatureGuard],
    data: {
      feature: EFeatureFlag.CUSTOM_FIELDS,
    },
  },
  {
    path: 'view/:customFieldId',
    component: CustomFieldDetailsComponent,
    canActivate: [FeatureGuard],
    data: {
      feature: EFeatureFlag.CUSTOM_FIELDS,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
})
export class CustomFieldRoutingModule {}
